import { Home } from "./Home";
export const HOME = {
    path: "/",
    component: Home,
};
